import { GridModel } from "common/models/utility-models/list-utility.model";
import { MentoringReportsModel } from "./mentoring-data-model";

export class MentoringReportsGridModel extends MentoringReportsModel { }

export class MentoringReportsListingModel extends GridModel<MentoringReportsModel> {
    filterData: any;
}